import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .action {
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         margin-top: 3px;
         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
      }
   }
   .select {
      h4 { width: 70px; }
      &:not(:first-of-type) {
         margin-top: 10px;
      }
   } 
   .textInput {
      h4 {
         width: 88px;
      }
      &:not(:first-of-type) {
         margin-top: 10px;
      }
   }
   .textarea {
      margin-top: 10px;

      > div {
         height: 100px;
         min-height: 100px;
         max-height: 150px;
      }
   }
   .headers {
      text-align: right;
      margin-top: 15px;
      > div { padding-top: 0; }
   }
   .filter {
      margin-top: 30px;
      margin-bottom: 5px;
   }
   .filesEdit {
      top: -18px !important;
      right: calc(100% + 23px) !important;
      z-index: 1;
   }
`;